module.exports = __webpack_public_path__ + "img/product-eva.9d4723db.png";